export default __webpack_public_path__ + "static/media/Snd_LowerDUpHigher.ca62932f.mp3";